'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _reactChartjs = require('react-chartjs-2');

var _colors = require('../../utils/colors');

var _demographics = require('../../utils/demographics');

var _constants = require('../../utils/constants');

var _formatting = require('../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getGraphLabelFormatting = function getGraphLabelFormatting(tooltipItem, data) {
  var label = data.labels[tooltipItem.index];
  var datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
  return label + ' - ' + (0, _formatting.percentFormatted)(datasetLabel) + '%';
};

var getBarOptions = function getBarOptions() {
  return {
    tooltips: {
      mode: 'single',
      intersect: false,
      callbacks: {
        label: function label(tooltipItem, data) {
          return getGraphLabelFormatting(tooltipItem, data);
        }
      }
    },
    responsive: true,
    showScale: false,
    scales: {
      xAxes: [{
        stacked: true
      }],
      yAxes: [{
        stacked: true
      }]
    }
  };
};

var getAgeGraph = function getAgeGraph(data) {
  var sortedData = (0, _lodash2.default)(data).toPairs().sortBy(0).fromPairs().value();
  var values = (0, _demographics.reduceGraphDataByGender)(sortedData);
  var ageGroups = _lodash2.default.flattenDeep(_lodash2.default.map(values, function (value) {
    return _lodash2.default.map(value, 'group');
  }));
  return {
    labels: _lodash2.default.uniq(ageGroups),
    datasets: [{
      label: _constants.GENDERS.M.text,
      backgroundColor: _colors.dyzioPalette.blue,
      borderColor: _colors.dyzioPalette.blue,
      borderWidth: 1,
      hoverBackgroundColor: _colors.dyzioPalette.blue,
      hoverBorderColor: _colors.dyzioPalette.blue,
      data: _lodash2.default.map(values.M || [], 'percentage')
    }, {
      label: _constants.GENDERS.F.text,
      backgroundColor: _colors.dyzioPalette.pink,
      borderColor: _colors.dyzioPalette.pink,
      borderWidth: 1,
      hoverBackgroundColor: _colors.dyzioPalette.pink,
      hoverBorderColor: _colors.dyzioPalette.pink,
      data: _lodash2.default.map(values.F || [], 'percentage')
    }, {
      label: _constants.GENDERS.U.text,
      backgroundColor: _colors.dyzioPalette.grey,
      borderColor: _colors.dyzioPalette.grey,
      borderWidth: 1,
      hoverBackgroundColor: _colors.dyzioPalette.grey,
      hoverBorderColor: _colors.dyzioPalette.grey,
      data: _lodash2.default.map(values.U || [], 'percentage')
    }]
  };
};

var DemographicsAgeGraph = function DemographicsAgeGraph(_ref) {
  var data = _ref.audienceDemographics.data;

  var graphData = getAgeGraph(data);
  var graphOptions = getBarOptions();
  return _react2.default.createElement(_reactChartjs.HorizontalBar, { data: graphData, options: graphOptions });
};

DemographicsAgeGraph.propTypes = {
  audienceDemographics: _propTypes2.default.object.isRequired
};

exports.default = DemographicsAgeGraph;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/demographics-age-graph/index.js
 ** module id = 241
 ** module chunks = 0
 **/